import type { List } from 'immutable';

const sortOrderForAppsToFilter: {
	[key: string]: number;
} = {
	'com.github.integration.production': 1,
	'com.xiplink.jira.git.jira_git_plugin': 2,
	'gitlab-jira-connect-gitlab.com': 3,
};

/**
 * Our marketing label filter 'Jira-Git' currently returns four apps. We are removing the 4th app called 'Dev Info for Jira'
 * from 'BigBrassBrand' as it is not popular and also to keep the UI aligned and neat with just 3 apps in one row.
 *
 * We are filtering based on the whitelisted list of apps to protect us from the filter getting modified in the future.
 *
 * @param list
 * @returns {List<*>}
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const filterWhitelistedApps = (list: List<any>): List<any> =>
	list.filter((record) => record.get('addonKey') in sortOrderForAppsToFilter);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getAppOrder = (hitRecord: any) => sortOrderForAppsToFilter[hitRecord.get('addonKey')];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const removeRatings = (list: List<any>): List<any> =>
	list.map((record) => record.remove('ratings'));

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const removeMarketingLabels = (list: List<any>): List<any> =>
	list.map((record) => record.remove('marketingLabels'));

/**
 * This function does the following things
 * 1. Filters for only the whitelisted apps
 * 2. Sorts them
 * 3. Remove review from them as we don't want to show them
 * 4. Remove market labels from them as we don't want to show the badges
 *
 * @param list
 * @returns {this}
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const transformMarketplaceApps = (list: List<any>): List<any> =>
	removeMarketingLabels(removeRatings(filterWhitelistedApps(list))).sortBy(getAppOrder);
